import { render, staticRenderFns } from "./wareDetail.vue?vue&type=template&id=fee2e02a&scoped=true"
import script from "./wareDetail.vue?vue&type=script&lang=js"
export * from "./wareDetail.vue?vue&type=script&lang=js"
import style0 from "./wareDetail.vue?vue&type=style&index=0&id=fee2e02a&prod&lang=scss&scoped=true"
import style1 from "./wareDetail.vue?vue&type=style&index=1&id=fee2e02a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fee2e02a",
  null
  
)

export default component.exports